import { TextInput } from '@interstate/components/TextInput';

import FieldOverrideIndicator from './FieldOverrideIndicator.interstate';
import { useFinanceTermField } from './hooks/useFinanceTermField';

const FinanceTermField = ({ isSummaryTab }: { isSummaryTab?: boolean }) => {
    const { label, overrideIndicatorProps, inputProps } = useFinanceTermField({ isSummaryTab });

    return (
        <FieldOverrideIndicator {...overrideIndicatorProps}>
            <TextInput label={label} {...inputProps} />
        </FieldOverrideIndicator>
    );
};

export default FinanceTermField;
